// extracted by mini-css-extract-plugin
export default {"form":"Form_form__xSsFL","row":"Form_row__EkagU","buttons":"Form_buttons__cU5nL","flag":"Form_flag__Z-ZjM","loading":"Form_loading__cJUGv","ctaLink":"Form_ctaLink__Dk5v-"};